// "Today" in the business's timezone. UTC would date invoices created between
// midnight and 01:00/02:00 Slovak time to the previous day.

const BUSINESS_TZ = "Europe/Bratislava";

// en-CA formats as YYYY-MM-DD.
const isoDateFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: BUSINESS_TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function todayIso(now: Date = new Date()): string {
  return isoDateFmt.format(now);
}

export function currentYear(now: Date = new Date()): number {
  return Number(todayIso(now).slice(0, 4));
}
